export const previewDeviceData = {
  customCodes: '管理编号/出厂编号',
  devName: '设备名称',
  devModel: '型号',
  checkOrg: '校准检定单位',
  lsCheckTime: '校准检定时间',
  nxCheckTime: '使用期限',
  t6: '固定资产编号',
  customDeviceUrl: `https://qsjc.dunchong.cc/qsjc/uploadPath/mpdevice?id=2c942eb49bbbe799019bbf8a89570064`
};
